import { Link } from "react-router-dom";

export default function CTASection() {
  return (
    <section className="relative py-16 md:py-24 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20gradient%20abstract%20background%20with%20soft%20geometric%20shapes%2C%20orange%20and%20coral%20tones%2C%20modern%20minimal%20design%2C%20subtle%20texture%2C%20clean%20and%20inviting%20atmosphere&width=1600&height=600&seq=cta-bg-home&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-r from-primary-500/90 to-primary-600/90"></div>

      <div className="relative z-10 max-w-[1280px] mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-4xl font-bold text-white mb-4">
          准备好开始追番了吗？
        </h2>
        <p className="text-sm md:text-base text-white/80 max-w-xl mx-auto mb-8">
          海量动漫资源，每日更新，免费在线观看与下载。加入51动漫官网，开启你的二次元之旅！
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/japanese"
            className="px-8 py-3 bg-white text-primary-600 font-semibold rounded-full text-sm hover:bg-white/90 transition-all cursor-pointer whitespace-nowrap"
          >
            <i className="ri-play-circle-fill mr-1.5"></i>开始观看
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 bg-white/15 text-white font-medium rounded-full text-sm hover:bg-white/25 transition-all cursor-pointer whitespace-nowrap border border-white/20"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}